<!--
 * @Author: your name
 * @Date: 2021-09-24 16:03:01
 * @LastEditTime: 2021-09-24 16:03:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \pc\src\components\business\medical-educate\paper\index.vue
-->
   // answer 带答案列表   noanswer不带答案列表
   // formData: {
      //   dataId: 0, 直播或着病例的ID
      //   moduleId: 0, 模块ID
      //   submitTotalCredit: 0, 学员提交的试题总分值
      //   totalCredit:0, 试题总分值
      //   examVOList: [ 试题列表
      //     {
      //       content: '', 问题内容
      //       dataId: 0, 直播或着病例的ID
      //       id: 0, 主键
      //       moduleId: 0, 模块ID
      //       platformId: 0, 平台id
      //       questionCredit: 0, 试题分值
      //       questionType: 0,试题类型 1 单选，2多选
      //       submitAnswer: 0,学员提交的答案
      //       submitQuestionCredit: 0,学员提交的试题分值
      //       trueAnswer: '',正确答案
      //       examOptionsVO: [ 试题选项列表
      //         {
      //           content: '', 选项内容
      //           id: 0, 主键
      //           isTrue: true, 是否为正确答案：0不是，1是
      //           sorted: '' 选项顺序,A,B,C..
      //         }
      //       ]
      //     }
      //   ]
      // }
<template>
  <div>
    <!-- <el-button @click="submit">提交</el-button> -->
    <div class="top_h"></div>
    <div v-if="$route.query && $route.query.id"  class="len">考试时长：{{ timeLengh }} 分钟</div>

    <div v-if=" option == 1 " class="noanswer_content">
      <!-- <span>临床病例</span> -->
      <div v-for=" (item,index) in formData.examVOList" :key="item.id" style="margin-top:10px">
        <div>
          <div class="noanswer_title">
            <div :class="item.questionType == 1 ? 'noanswer_title_img cl1' : 'noanswer_title_img cl2' ">{{item.questionType == 1 ? '单' : '多' }}</div>
            <div class="noanswer_title_content"> {{(index+1) >=9 ? (index + 1) : ('0' + (index+1))}}. {{item.content}} {{item.questionCredit}} (分）:</div>
          </div>
        </div>
        <div class="select_size">
          <!-- <el-radio-group v-if="item.questionType == 1" v-model="item.submitAnswer[0]">
            <el-radio v-for="option in item.examOptionsVO" :key="option.id" :label="option.sorted">{{option.sorted}}.{{option.content}}</el-radio>
          </el-radio-group> -->
          <van-radio-group v-if="item.questionType == 1" v-model="item.submitAnswer[0]">
            <van-radio icon-size="18px" v-for="option in item.examOptionsVO" :key="option.id" :name="option.sorted">{{option.sorted}}.{{option.content}}</van-radio>
          </van-radio-group>
          <!-- <el-checkbox-group v-if="item.questionType == 2" v-model="item.submitAnswer" @change="handleCheckedCitiesChange(item.submitAnswer)">
            <el-checkbox v-for="option in item.examOptionsVO" :key="option.id" :label="option.sorted">{{option.sorted}}.{{option.content}}</el-checkbox>
          </el-checkbox-group> -->
          <van-checkbox-group v-if="item.questionType == 2" v-model="item.submitAnswer[0]" @change="handleCheckedCitiesChange(item.submitAnswer)">
            <van-checkbox shape="square" v-for="option in item.examOptionsVO" :key="option.id" :name="option.sorted">{{option.sorted}}.{{option.content}}</van-checkbox>
          </van-checkbox-group>
        </div>
      </div>
    </div>
    <div v-if=" option ==2" class='total_color'>
      <div class="top">我的成绩：{{formData.submitTotalCredit}}分 <span class="top_right">（ 满分 {{formData.totalCredit}} 分）</span></div>
      <div v-for=" (item,index) in formData.examVOList" :key="item.id" style="margin-top:10px">
        <div :class="getTrue(item.submitAnswer, item.trueAnswer) == 'mistake' ? 'cu' : 'right' ">本题得分：{{item.submitQuestionCredit}}分（本题分值：{{item.questionCredit}}分） <span style="margin-left:5px;font-size:12px">正确答案：{{getAnswer(item.trueAnswer)}}</span> <span style="margin-left:5px" :class="getTrue(item.submitAnswer, item.trueAnswer) == 'mistake' ? 'cu_color' : '' ">学员答案：{{getAnswer(item.submitAnswer)}}</span></div>
        <div class="content">
          <div class="content_ner">
            <div class="content_top">{{(index+1) >=9 ? (index + 1) : ('0' + (index+1))}}. {{item.content}} ( {{item.questionCredit}}分 ):</div>
            <div class="select_size">
              <el-radio-group v-if="item.questionType == 1" v-model="item.submitAnswer[0]">
                <el-radio disabled v-for="option in item.examOptionsVO" :key="option.id" :label="option.sorted">{{option.sorted}}.{{option.content}}</el-radio>
              </el-radio-group>
              <el-checkbox-group v-if="item.questionType == 2" v-model="item.submitAnswer">
                <el-checkbox disabled v-for="option in item.examOptionsVO" :key="option.id" :label="option.sorted">{{option.sorted}}.{{option.content}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
export default {
  props: {
    formData: {
      type: Object,
      default: () => {}
    },
    option: {
      type: Number,
      default: 1
    },
    timeLengh: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {};
  },
  methods: {
    getAnswer (team) {
      const array = team;
      let alist = '';
      array.map((item) => {
        alist = alist + item;
      });
      return alist;
    },
    // 题目对错

    getTrue (item, option) {
      if (item.length === option.length) {
        for (let i = 0; i < item.length; i++) {
          if (!option.includes(item[i])) {
            return 'mistake';
          }
        }
        return 'right';
      } else {
        return 'mistake';
      }
    },

    handleCheckedCitiesChange (item) {
      const array = []
      item[0].map(ots => {
        array.push(ots)
      })
      array.sort()
      item[0] = array
    }
  },

  created () {},

  mounted () {}
};
</script>
  <style lang="scss" scoped>
/* @import url(); 引入css类 */
.top_h {
  width: 100%;
  height: 10px;
}
.total_color {
  margin-top:50px;
  background-color: rgb(245, 245, 245);
}
.noanswer_content {
  width: 100%;
  margin-top:50px;
  // padding: 16px 20px 16px 14px;
  background-color: rgb(245, 245, 245);
}
.noanswer_title {
  display: flex;
  padding: 16px 20px 0px 14px;
  background: #ffffff;
  justify-content: flex-start;
  // width: calc(100vw - 28px);
}
.noanswer_title_img {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  font-family: PingFangSC-Medium;
  font-size: 10px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
  margin-right: 8px;
}
.cl1 {
  background: #537dff;
}
.cl2 {
  background: #398e5d;
}
.noanswer_title_content {
  // margin-left:-20px;
  // margin-top: 20px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 500;
}
.select_size {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
  padding: 10px 20px 16px 14px;
  background: #ffffff;
  letter-spacing: 0.17px;
  font-weight: 400;
  //  padding-left: 14px;
}
.van-radio {
  margin-top: 24px;
  align-items: flex-start;
    word-break:break-all;
}
.van-checkbox{
  align-items: flex-start;
  margin-top: 24px;
    word-break:break-all;
}
::v-deep .el-radio {
  margin-top: 24px;
  display: flex;
  line-height: 18px;
  white-space: normal;
  margin-right: 0;
  word-break:break-all;
}
::v-deep .el-checkbox {
  margin-top: 24px;
  display: flex;
  line-height: 18px;
  white-space: normal;
  margin-right: 0;
  word-break:break-all;
}
.content {
  display: flex;
  width: 100%;
  background: #ffffff;
  // border-left: 1px solid #c1c1c1;
  // border-right: 1px solid #c1c1c1;
  // border-bottom: 1px solid #c1c1c1;
  // border-radius: 2px;
  padding: 16px 20px 16px 14px;
  font-family: PingFangSC-Medium;
  font-size: 14px;
}
.top {
  width: 100%;
  height: 40px;
  background: #f6ffed;
  // background: #ffffff;
  line-height: 40px;
  padding-left: 14px;
  margin-top: 10px;
  border: 1px solid #b7eb8f;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #333333;
  font-weight: 500;
}
.top_right {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
  margin-left: 10px;
}
.right {
  width: 100%;
  height: 45px;
  line-height: 45px;
  background: #f6ffed;
  border-radius: 2px 2px 0px 0px;
  padding-left: 14px;
  // border-left: 1px solid #c1c1c1;
  // border-right: 1px solid #c1c1c1;
  border-top: 1px solid #c1c1c1;
  border-bottom: 1px solid #c1c1c1;
  // background: rgba(0, 0, 0, 0.02);
  // box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.06);
  // border-radius: 2px 2px 0px 0px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
}
.cu {
  width: 100%;
  height: 45px;
  line-height: 45px;
  padding-left: 24px;
  background: #fff1f0;
  border-radius: 2px 2px 0px 0px;
  padding-left: 14px;
  border-top: 2px solid #ffa39e;
  border-bottom: 2px solid #ffa39e;

  // border: 2px solid #ffa39e;
  // box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.06);
  // border-radius: 2px 2px 0px 0px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
}
.content_ner {
  width: 100vw;
}
.content_top {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 500;
}
.cu_color {
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #ff4d4f;
  font-weight: 500;
}
.len{
  margin-top:50px;
  margin-bottom: -40px;
  margin-left: 5px;
}
</style>
